import React from 'react';
import './TradeGroupTabs.css';

export type TradeGroupTabId = 'orders' | 'adjustments' | 'ranges' | 'timeline' | 'activity';

export interface TradeGroupTab {
  id: TradeGroupTabId;
  label: string;
  count?: number;
}

interface TradeGroupTabsProps {
  activeTab: TradeGroupTabId;
  onTabChange: (tabId: TradeGroupTabId) => void;
  tabs: TradeGroupTab[];
}

const TradeGroupTabs: React.FC<TradeGroupTabsProps> = ({
  activeTab,
  onTabChange,
  tabs,
}) => {
  // Handle keyboard navigation
  const handleKeyDown = (event: React.KeyboardEvent, currentIndex: number) => {
    let newIndex = currentIndex;
    
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      newIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      newIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
    } else if (event.key === 'Home') {
      event.preventDefault();
      newIndex = 0;
    } else if (event.key === 'End') {
      event.preventDefault();
      newIndex = tabs.length - 1;
    } else {
      return; // Don't change tab for other keys
    }
    
    onTabChange(tabs[newIndex].id);
  };

  return (
    <div 
      className="trade-group-tabs" 
      role="tablist" 
      aria-label="Trade group information tabs"
    >
      {tabs.map((tab, index) => (
        <button
          key={tab.id}
          className={`trade-group-tab ${activeTab === tab.id ? 'active' : ''}`}
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-controls={`trade-group-panel-${tab.id}`}
          id={`trade-group-tab-${tab.id}`}
          onClick={() => onTabChange(tab.id)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          type="button"
          tabIndex={activeTab === tab.id ? 0 : -1}
        >
          <span className="tab-label">{tab.label}</span>
          {tab.count !== undefined && tab.count > 0 && (
            <span className="tab-count" aria-label={`${tab.count} items`}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default TradeGroupTabs;
